import {env} from './EnvironmentConfig';
class PrefixPath{
    static APP_NAME = 'All-Access-Hub';
    static API_BASE_URL = env?.baseUrl[0];
    static AAL_API_BASE_URL = env?.aalBaseUrl;
    static APP_VERSION = env?.appVersion;
    static RIC_API_BASE_URL = env?.baseUrl[1];
    static SMS_API_BASE_URL = env?.baseUrl[3];
    static API_KEY = env?.apiKey;
    static MUI_License_KEY = env?.muiLicenseKey || "";
    static AAL_API_KEY = env?.aalApiKey;
    static APP_PREFIX_PATH = '/AAM';
    static AUTH_PREFIX_PATH = '/auth';
static DEVELOPER_ID='0703a81c'
static HASH_KEY='a2bfc11b-616f-4692-b814-c0b988b0f577'
static USER_ID='11efabfd41d6322ab1d35a10'
static LOCATION_ID='11efabfd3a8ee0e8aa0edb8c'
static CC_PRODUCT_TRANSACTION_ID='11efabfd3b651c44b92d3b2b'
static ACH_PRODUCT_TRANSACTION_ID='11efabfd3f4a3d089d586066'
}
export default PrefixPath;